import {VolatilityChange} from "./VolatilityChange";

export class VolatilityMovers {
    public readonly gainers: Array<VolatilityChange>;
    public readonly losers: Array<VolatilityChange>;

    public constructor(changes: Array<VolatilityChange>) {
        this.gainers = changes.filter(c => c.changePct > 0);
        this.losers = changes.filter(c => c.changePct < 0);
    }
}
